export type AdviceObjectType = 'FIELD' | 'SUBUNIT';

export const AdviceObjectType = {
  FIELD: 'FIELD' as AdviceObjectType,
  SUBUNIT: 'SUBUNIT' as AdviceObjectType,
};
